export enum GridLayoutLoadingType {
    Unset = 0,
    None = 1,
    Grid = 2,
    GridAndHeader = 3,
    Map = 4,
    MapAndHeader = 5
}